<template>
<v-dialog
	v-model="exportMenu"
	width="700"
>
	<v-card style="width: 100%">
		<v-container fluid>
			<h1 class="export-menu__caption">{{ $t('workers.exportMenu.caption') }}</h1>
			<v-layout wrap align-center>
				<v-flex sm4 d-flex>
					<v-select
						v-model="selectedType"
						:items="types"
						:label="$t('workers.exportMenu.typeLabel')"
					>
						<template slot="selection" slot-scope="data">
							{{ $t('workers.exportMenu.type_' + data.item) }}
						</template>
						<template slot="item" slot-scope="data">
							{{ $t('workers.exportMenu.type_' + data.item) }}
						</template>
					</v-select>
				</v-flex>
				<v-flex sm8 d-flex v-if="selectedType == 'interval'">
					<v-layout>
						<v-flex sm6>
							<Datepicker
								:error-messages="validate.date"
								:label="$t('workers.job_start')"
								v-model="payDate.start"
							/>
						</v-flex>
						<v-flex sm6>
							<Datepicker
								:error-messages="validate.date"
								:label="$t('workers.job_end')"
								v-model="payDate.end"
							/>
						</v-flex>
					</v-layout>
				</v-flex>
					<v-flex sm8 d-flex v-if="selectedType == 'latestMonths'">
					<v-layout>
						<v-flex sm6>
							<v-text-field
								:label="$t('workers.numberOfMonths')"
								v-model="numberOfMonth"
							/>
						</v-flex>
					</v-layout>
				</v-flex>

			</v-layout>
		<v-card-actions>
			<v-flex offset-sm2 sm8 d-flex>
				<DownloadExel
					v-if="selectedType"
					:is-loading="isDownloadReport"
					@load="exportFilterWorkers"
					:file="workersFile"
					@onClear="clearFile"
					:textButton="$t('workers.filters.exportButton')"
				/>
			</v-flex>

			<v-spacer></v-spacer>
			<v-btn
				color="red light-1"
				flat
				@click="exportMenu = false"
			>
				{{$t('common.cancel')}}
			</v-btn>
		</v-card-actions>
		</v-container>
	</v-card>
</v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validateDataStartEnd } from '../../utils/helpers'
import Datepicker from '../../components/DatePicker'
import DownloadExel from '../../components/DownloadExel'

export default {
	components: {
		Datepicker,
		DownloadExel
	},
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		selectedType: null,
		types: ['interval', 'lastPays', 'latestMonths'],
		payDate: {
			start: null,
			end: null
		},
		numberOfMonth: 3,
	}),
	computed: {
		...mapState({
			workersFile: ({ workers }) => workers.workersFile,
			isDownloadReport: ({ workers }) => workers.isDownloadReport
		}),
		exportMenu: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		},
		validate() {
			const { start, end } = this.payDate
			const date = validateDataStartEnd(start, end)
				? this.$t('workers.start_end_valid')
				: null
			return {
				date
			}
		}
	},
	methods: {
		...mapMutations({
			clearFile: 'workers/setWorkersFile'
		}),
		exportFilterWorkers() {
			const error = Object.values(this.validate).find(error => error)
			if (error) return false
			let query = {
				exportType: this.selectedType
			}
			if (this.selectedType == 'interval') {
			 	query.payDate = this.payDate
			}

			if(this.selectedType == 'latestMonths') {
				query.numberOfMonth = this.numberOfMonth
			}

			this.$emit('export', query)
			this.exportMenu = false
		}
	},
	watch: {
		exportMenu() {
			if(this.exportMenu) {
				this.selectedType = null
				this.payDate = {
					start: null,
					end: null
				}
			}
		}
	}
}
</script>

<style>
.link-file-hide {
	display: none;
}
.export-menu__caption {
	color: #696666;
}

</style>
